module.exports = __webpack_public_path__ + "static/unlock-stars2-2e974326dbfaafe67f2c419333865fe1.mp3";